export default __webpack_public_path__ + "static/media/banner.47eb26f6.png";